<template>
  <div>
    <b-card>
      <p class="h2">物件管理</p>
      <p>住宅3Dデータに対し、ロック/ロック解除、公開/非公開、削除の設定ができます。 </p>
      <hr class="my-3">
      <b-input-group>
      <div class="callout callout-success">
        <small class="text-muted h6">同時公開数</small><br>
        <spinner v-show="isLoadingUserInfo" :line-size="2" :size="26" :speed="0.8" line-fg-color="#B23E53"></spinner>
        <strong v-show="!isLoadingUserInfo" class="h4"> {{ strPublic }}</strong>
      </div><br>
      <div class="callout callout-success">
        <small class="text-muted h6">最大保存数</small><br>
        <spinner v-show="isLoadingUserInfo" :line-size="2" :size="26" :speed="0.8" line-fg-color="#B23E53"></spinner>
        <strong v-show="!isLoadingUserInfo" class="h4"> {{ strUpload }}</strong>
      </div>
      <b-button class="align-self-center" variant="primary" style="margin-left:10px; height: 36px;" @click="refresh()">
        <i class="fa fa-refresh"></i> 更新
      </b-button>
      </b-input-group>
      <b-alert show v-show="showErrorPublic" variant="danger">{{ errorPublic }}</b-alert>
      <b-alert show v-show="showErrorUpload" variant="danger">{{ errorUpload }}</b-alert>
      <p>現在利用コース ： {{ gradename }} </p>
      <!-- <b-button variant="primary" href="#/Grade" style="float: left">
        <i class="fa icon-credit-card"></i> コース変更
      </b-button> -->
    </b-card>
    <b-card>
      <form @submit.prevent="startSearch()">
        <div>
        <form class="form-inline" @submit.prevent="startSearch()">
          <div class="form-group ">
            <select class="form-control" id="exampleFormControlSelect1" v-model="dispSelected" style="height: auto; margin-left: 8px;">
              <option value="all">すべて</option>
              <option value="public">公開のみ</option>
              <option value="private">非公開のみ</option>
              <option value="protect">ロックのみ</option>
              <option value="unlock">ロック解除のみ</option>
            </select>
          </div>
          <div class="form-group mx-sm-3">
            物件名
            <b-form-input type="text" v-model="serachInputText" placeholder="キーワード入力" style="margin-left: 8px;"></b-form-input>
          </div>
          <div class="form-group mx-sm-3">
            表示件数
            <select class="form-control" v-model.number="dispCount" style="height: auto; margin-left: 8px;">
              <option>12</option>
              <option>36</option>
              <option>48</option>
              <option>96</option>
            </select>
          </div>

          <b-button variant="primary" @click="startSearch()">
            <i class="fa fa-search"></i> 検索
          </b-button>
        </form>
        </div>
        <!-- <b-form-group>
          <b-input-group>
            <select class="form-control" id="exampleFormControlSelect1" v-model="dispSelected" style="height: auto;">
              <option value="public">公開のみ</option>
              <option value="private">非公開のみ</option>
              <option value="protect">ロックのみ</option>
              <option value="all">すべて</option>
              <option value="top">100物件</option>
            </select>
            <b-form-input type="text" v-model="serachInputText" placeholder="キーワード入力"></b-form-input>
            <b-button variant="primary" @click="startSearch()">
              <i class="fa fa-search"></i> 検索
            </b-button>
          </b-input-group>
        </b-form-group> -->
      </form>
    </b-card>
    <div class="row">
      <div style="padding-left: 16px;">
        <b-button variant="gray-700" @click="checkOn()">
          <i class="fa fa-check"></i>全て選択
        </b-button>
      </div>
      <div style="padding-left: 16px;">
        <b-button variant="gray-700" @click="checkOff()">
          <i class="fa fa-check"></i>全選択解除
        </b-button>
      </div>
      <div style="padding-left: 16px;">
        <b-dropdown id="ddown-buttons" text="選択中の物件編集" variant="primary" v-bind:disabled="selectCount==''">
          <b-dropdown-item-button v-show="!disabledSelectedPublic" @click="PublicPlanList()"><i class="fa fa-eye"></i>公開</b-dropdown-item-button>
          <b-dropdown-item-button v-show="!disabledSelectedPrivate" @click="PrivatePlanList()"><i class="fa fa-eye-slash"></i>非公開</b-dropdown-item-button>
          <b-dropdown-item-button v-show="!disabledSelectedLock" @click="LockPlanList()"><i class="fa fa-lock"></i>ロック（モデルハウス用）</b-dropdown-item-button>
          <b-dropdown-item-button v-show="!disabledSelectedUnlock" @click="UnlockPlanList()"><i class="fa fa-unlock"></i>ロック解除</b-dropdown-item-button>
          <b-dropdown-item-button v-show="!disabledSelectedDelete" @click="CheckDeletePlanList()"><i class="fa fa-eraser"></i>削除</b-dropdown-item-button>
        </b-dropdown>
      </div>
      <div class="align-self-end" style="padding-left: 16px; color: #333333;">
        {{ selectCount }}
      </div>
    </div>
    <div class="row" style="padding-top: 20px;">
        <spinner v-show="isLoadingPlanList" id="listloader" :line-size="6" :size="100" :speed="0.8" line-fg-color="#B23E53" text-fg-color="#FFF" :font-size="20" :spacing="5" message="更新中..."></spinner>
        <Card class="col-md-3" v-for="item in getDispItems()" :key="item.planid" :PlanData="item" :CheckFlg="item.checkFlg" :PublicFlg="item.publicflg" :ProtectFlg="item.protectflg" :SelectedFlg="selected" :GradeName="gradename" @delete-event="deletePlanMethod" @update-event="updateUserMethod" @check-event="checkMethod" @click-event="onCardClick"></Card>
    </div>
   <b-pagination :total-rows="getRowCount()" :per-page="perPage" v-model="currentPage" prev-text="前へ" next-text="次へ"/>
   <loading v-show="isLoadingFull" msg="更新中..."></loading>
   <b-modal v-model="errorshow" centered title="" ok-title='OK' body-text-variant="" ok-only>
    {{ errortext }}
   </b-modal>
   <b-modal v-model="deletestartshow" centered title="" ok-title='OK' cancel-title="キャンセル" body-text-variant="" @ok="DeletePlanList()">
    選択したデータを削除すると復元できませんが、削除しますか？
   </b-modal>
  </div>
</template>

<script>
import Card from './PlanCard'
import Store from '@/store'
import ApiAccess from '@/components/ApiAccess'
import Spinner from 'vue-simple-spinner'
import Loading from '../../components/Loading'

export default {
  mixins: [ ApiAccess ],
  components: {
    Loading,
    Card,
    Spinner
  },
  watch: {
    currentPage: function (val) {
      this.updateSelectCount()
    }
  },
  data: () => {
    return {
      items: [],
      currentPage: 1,
      perPage: 12,
      totalRows: 0,
      isLoadingPlanList: false,
      isLoadingUserInfo: false,
      gradename: '',
      strPublic: '',
      strUpload: '',
      searchFlg: false,
      serachInputText: '',
      searchText: '',
      errorPublic: '',
      errorUpload: '',
      showErrorPublic: false,
      showErrorUpload: false,
      dispSelected: 'all',
      isLoadingFull: false,
      searchState: 'all',
      selectCount: '',
      errorshow: false,
      errortext: '',
      deletestartshow: false,
      dispCount: 12,
      selected: false,
      disabledSelectedPublic: false,
      disabledSelectedPrivate: false,
      disabledSelectedLock: false,
      disabledSelectedUnlock: false,
      disabledSelectedDelete: false
    }
  },
  created: function () {
    this.getDatas()
  },
  methods: {
    getBadge (status) {
      return status === 'Active' ? 'success'
        : status === 'Inactive' ? 'secondary'
          : status === 'Pending' ? 'warning'
            : status === 'Banned' ? 'danger' : 'primary'
    },
    getRowCount () {
      return this.getAllItems().length
    },
    getDispItems () {
      return this.getAllItems().slice(this.currentPage * this.perPage - this.perPage, this.currentPage * this.perPage)
    },
    updateUserInfo: async function () {
      this.isLoadingUserInfo = true
      var userInfo = await this.$_Api_GetUserInfo(Store.state.token, Store.state.companyid)
      this.gradename = userInfo.data.gradename
      if (userInfo.data.limitpublic >= 1000000) {
        this.strPublic = ' ' + userInfo.data.countpublic + ' / ' + '∞'
        this.strUpload = ' ' + userInfo.data.countuplaod + ' / ' + '∞'
      } else {
        this.strPublic = ' ' + userInfo.data.countpublic + ' / ' + userInfo.data.limitpublic
        this.strUpload = ' ' + userInfo.data.countuplaod + ' / ' + userInfo.data.limitupload
      }

      if (userInfo.data.limitpublic < userInfo.data.countpublic) {
        this.errorPublic = '同時公開数が契約コースの上限を超えています。コースを変更するか、同時公開数の上限を下回るまで公開数を減らしてください。'
        this.showErrorPublic = true
      } else {
        this.errorPublic = ''
        this.showErrorPublic = false
      }
      if (userInfo.data.limitupload < userInfo.data.countuplaod) {
        this.errorUpload = '最大保存数が契約コースの上限を超えています。コースを変更するか、最大保存数の上限を下回るまで削除してください。'
        this.showErrorUpload = true
      } else {
        this.errorUpload = ''
        this.showErrorUpload = false
      }
      this.isLoadingUserInfo = false
      this.updateSelectCount()
    },
    getDatas: async function () {
      await this.updateUserInfo()
      this.isLoadingPlanList = true
      var planList = await this.$_Api_GetPlanList(Store.state.token, Store.state.companyid)
      for (var i = 0; i < planList.length; i++) {
        planList[i].checkFlg = false
      }
      this.items = planList
      this.isLoadingPlanList = false
    },
    removePlan (planid) {
      for (var i = 0; i < this.items.length; i++) {
        if (this.items[i].planid === planid) {
          this.items.splice(i, 1)
        }
      }
    },
    deletePlanMethod: async function (planid) {
      this.removePlan(planid)
      await this.updateUserInfo()
    },
    async updateUserMethod () {
      await this.updateUserInfo()
    },
    async checkMethod () {

    },
    isDispItem (item) {
      switch (this.searchState) {
        case 'public':
          return item.publicflg
        case 'private':
          return !item.publicflg
        case 'protect':
          return item.protectflg
        case 'unlock':
          return !item.protectflg
        case 'all':
          return true

        default:
          break
      }
      return true
    },
    getAllItems () {
      var searchItems = []
      if (this.searchFlg) {
        for (var i = 0; i < this.items.length; i++) {
          var itemi = this.items[i]
          if (!this.isDispItem(itemi)) continue
          if (itemi.name.indexOf(this.searchText) >= 0) {
            searchItems.push(itemi)
          }
        }
      } else {
        for (var j = 0; j < this.items.length; j++) {
          var itemj = this.items[j]
          if (!this.isDispItem(itemj)) continue
          searchItems.push(itemj)
        }
      }
      return searchItems
    },
    startSearch () {
      if (this.serachInputText === '') {
        this.searchFlg = false
        this.searchText = ''
      } else {
        this.searchFlg = true
        this.searchText = this.serachInputText
      }
      this.perPage = this.dispCount
      this.searchState = this.dispSelected
      this.updateSelectCount()
    },
    async refresh () {
      var prevPage = this.currentPage
      this.items.length = 0
      await this.getDatas()
      this.currentPage = prevPage
    },
    checkOn () {
      var dispItems = this.getDispItems()
      for (var i = 0; i < dispItems.length; i++) {
        var dispItem = dispItems[i]
        dispItem.checkFlg = true
      }
      this.updateSelectCount()
    },
    checkOff () {
      var dispItems = this.getDispItems()
      for (var i = 0; i < dispItems.length; i++) {
        var dispItem = dispItems[i]
        dispItem.checkFlg = false
      }
      this.updateSelectCount()
    },
    getCheckedItems () {
      var checkedItems = []
      var dispItems = this.getDispItems()
      for (var i = 0; i < dispItems.length; i++) {
        if (dispItems[i].checkFlg) {
          checkedItems.push(dispItems[i])
        }
      }
      return checkedItems
    },
    async PrivatePlanList () {
      this.isLoadingFull = true
      var items = this.getCheckedItems()
      await this.$_Api_PrivatePlanList(Store.state.token, Store.state.companyid, items)
      await this.updateUserInfo()
      this.isLoadingFull = false
    },
    async PublicPlanList () {
      this.isLoadingFull = true
      var items = this.getCheckedItems()
      var res = await this.$_Api_PublicPlanList(Store.state.token, Store.state.companyid, items)
      this.isLoadingFull = false
      if (res) {
        await this.updateUserInfo()
      } else {
        this.errortext = '公開設定できませんでした。同時公開数が契約コースの上限を超える場合公開できません。'
        this.errorshow = true
      }
    },
    async UnlockPlanList () {
      this.isLoadingFull = true
      var items = this.getCheckedItems()
      await this.$_Api_UnlockPlanList(Store.state.token, Store.state.companyid, items)
      this.updateSelectCount()
      this.isLoadingFull = false
    },
    async LockPlanList () {
      this.isLoadingFull = true
      var items = this.getCheckedItems()
      await this.$_Api_LockPlanList(Store.state.token, Store.state.companyid, items)
      this.updateSelectCount()
      this.isLoadingFull = false
    },
    CheckDeletePlanList () {
      this.deletestartshow = true
    },
    async DeletePlanList () {
      this.isLoadingFull = true
      var items = this.getCheckedItems()
      var res = await this.$_Api_DeletePlanList(Store.state.token, Store.state.companyid, items)
      this.isLoadingFull = false
      if (res === 'ok') {
        for (var i = items.length - 1; i >= 0; i--) {
          var deleteItem = items[i]
          this.removePlan(deleteItem.planid)
        }
        await this.updateUserInfo()
      } else {
        this.errortext = res
        this.errorshow = true
      }
    },
    async onCardClick (item) {
      item.checkFlg = !item.checkFlg

      this.updateSelectCount()
    },
    updateSelectCount () {
      var items = this.getCheckedItems()
      if (items.length > 0) {
        this.selectCount = items.length + '件選択中'
        this.selected = true
        this.checkSelectedDropdownState(items)
      } else {
        this.selectCount = ''
        this.selected = false
      }
    },
    PublicExists (items) {
      for (var i = 0; i < items.length; i++) {
        var item = items[i]
        if (item.publicflg) {
          return true
        }
      }
      return false
    },
    PrivateExists (items) {
      for (var i = 0; i < items.length; i++) {
        var item = items[i]
        if (!item.publicflg) {
          return true
        }
      }
      return false
    },
    LockExists (items) {
      for (var i = 0; i < items.length; i++) {
        var item = items[i]
        if (item.protectflg) {
          return true
        }
      }
      return false
    },
    UnlockExists (items) {
      for (var i = 0; i < items.length; i++) {
        var item = items[i]
        if (!item.protectflg) {
          return true
        }
      }
      return false
    },
    checkSelectedDropdownState (items) {
      this.disabledSelectedPublic = !this.PrivateExists(items)
      this.disabledSelectedPrivate = !this.PublicExists(items)
      this.disabledSelectedLock = !this.UnlockExists(items)
      this.disabledSelectedUnlock = !this.LockExists(items)
    }

  }
}
</script>

<style scoped>
#listloader {
  position: absolute;
  left: 50%;
  margin-left: -50px;
}

#userloader{
  position: absolute;
}

input {
  font-size: 16px;
}
.sidebar b-dropdown-item-button {
    color:  red;
    background-color: #000000 ;
}
</style>



// WEBPACK FOOTER //
// src/views/home/PlanItem.vue